import { PluginKey } from "@tiptap/pm/state";

/**
 * Stable key for the DynamicMention suggestion plugin so we can open the menu
 * over an existing mention via transaction meta (see `dynamicMentionSuggestion.ts`).
 */
export const dynamicMentionSuggestionPluginKey = new PluginKey(
  "dynamicMentionSuggestion"
);
